// **************************************************************************
// INTEREST RATES STATE
// Only contains operation loading states - actual data is in application/data store
// **************************************************************************
export interface InterestRatesState {
    updating: boolean;
}

export const initialInterestRatesState: InterestRatesState = {
    updating: false,
};
